import type { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { careEnvironment } from "@akina/config";
import type { AuthAppState } from "@akina/infra";
import { Auth0Provider } from "@auth0/auth0-react";

// Must be inside BrowserRouter to access navigation history
const AuthenticationProvider = ({ children }: { children: ReactNode }) => {
  const navigate = useNavigate();

  return (
    <Auth0Provider
      useRefreshTokens={true}
      useRefreshTokensFallback={true}
      cacheLocation="localstorage"
      onRedirectCallback={appState => {
        const state = appState as AuthAppState;
        if (state?.returnTo) {
          navigate(state.returnTo);
        }
      }}
      domain={careEnvironment.auth0Domain}
      clientId={careEnvironment.auth0ClientId}
      authorizationParams={{
        audience: careEnvironment.auth0Audience,
        redirect_uri: careEnvironment.auth0RedirectUri,
      }}>
      {children}
    </Auth0Provider>
  );
};

export default AuthenticationProvider;
